import styles from './datatable.module.scss'

// Single source for the themeable selected-row class (see `datatable.module.scss` for the
// contrast rationale). `Table`/`ActualRow` and `libs/task/webui`'s `TaskListRow` both consume
// this instead of each declaring their own copy of the same rule.
export const selectedRowClassName = styles.selectedRow
